import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { ObjectInspectorComponent } from './object-inspector.component';

@Component({
  selector: 'con-json-difference',
  templateUrl: './json-difference.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ObjectInspectorComponent],
})
export class JsonDifferenceComponent {
  @Input() object1: any;
  @Input() object2: any;

  private diff = '';
}
